export default __webpack_public_path__ + "static/media/hardhat-noun.694cd962.png";